// extracted by mini-css-extract-plugin
module.exports = {"progress-ring":"styles_progress-ring__1ItUz","progress-ring__circle":"styles_progress-ring__circle__1eJEe"};